import { postPaymentMethodConfirm } from 'apis/payment';
import { STATUS_ICON_SRC } from 'components/my/MyBookingCardList';
import { useTranslation } from 'i18n';
import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

const StatusContainer = styled.div`
  display: grid;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
  justify-items: center;
  margin-top: 30px;
`;

const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StatusText = styled.span<{ $status: string }>`
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
`;

export default function CardRegisterRedirectPage() {
  const { t } = useTranslation();
  const { status } = useParams<{ status: 'success' | 'failed' }>();
  const [searchParams] = useSearchParams();
  const setssionId = searchParams.get('session_id'); // si_xxx
  //status 확인해서 카드 등록 / 실패 페이지 처리 후 setupIntentId는 주문 서버로 전송

  const handlePaymentMethodSessionId = async () => {
    const res = await postPaymentMethodConfirm({ sessionId: setssionId });
    console.log(res, 'reg session id');
  };
  useEffect(() => {
    if (status === 'success' && setssionId) {
      handlePaymentMethodSessionId();
      console.log('success reg card');
    } else {
      console.log('failed reg card');
    }
  }, [status, setssionId]);

  //5초 후 창 닫기
  //카운트 설정
  const [count, setCount] = React.useState(5);

  useEffect(() => {
    if (count === 0) {
      window?.close();
      return;
    }

    const timer = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount <= 1) {
          clearInterval(timer); // 🔸 여기서 타이머 종료
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [count]);

  return (
    <StatusContainer>
      <StatusIcon>
        <img
          src={STATUS_ICON_SRC[status === 'success' ? "COMPLETED" : "CANCELED"]}
          alt={status}
          width={41}
          height={41}
        />
      </StatusIcon>
      <StatusText $status={status === 'success' ? "COMPLETED" : "CANCELED"}>
        {status === 'success' ? t('card_register.success') : t('card_register.failed')}
      </StatusText>
      <StatusText $status={status === 'success' ? "COMPLETED" : "CANCELED"}>
        {t('card_register.close_in_seconds', { seconds: count })}
      </StatusText>
    </StatusContainer>
  );
}
